import { ICompanyFormDataType } from "../forms/FormDataTypes";
import { ICompanyContract } from "../zeos-api/contracts/Company";

/**
 * Maps company form data to company contract payload. Mirrors
 * mapPropertyFormToContract (PropertyHelpers.ts) — same shape, same
 * "?? 0" default for the type id since neither form exposes it as an input
 * today (see CompanyForm.tsx, which has no companyType dropdown).
 * @param formData - The company form data
 * @param customerId - The customer ID to associate with the company
 * @param companyId - Optional company ID for updates (defaults to formData.companyId or 0)
 * @returns The company contract payload
 */
export const mapCompanyFormToContract = (
  formData: ICompanyFormDataType,
  customerId: number,
  companyId?: number
): ICompanyContract => {
  return {
    companyName: formData.companyName,
    companyTypeId: formData.companyTypeId ?? 0,
    address: formData.address,
    suite: formData.suite,
    city: formData.city,
    state: formData.state,
    zip: formData.zip,
    website: formData.website,
    companyId: companyId ?? Number(formData.companyId ?? 0),
    customerId: customerId,
  };
};
